<template>
	<div class="icon-copy">
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2256">
					<rect
						id="search"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2256)">
				<path
					id="Union"
					d="M16.5 16.5L16.85 16.5C20.76 16.5 22.5 14.76 22.5 10.8501L22.5 6.6499C22.5 2.73999 20.76 1 16.85 1L12.65 1C8.73999 1 7 2.73999 7 6.6499L7 7L6.65002 7C2.73999 7 1 8.73999 1 12.6499L1 16.8501C1 20.76 2.73999 22.5 6.65002 22.5L10.85 22.5C14.76 22.5 16.5 20.76 16.5 16.8501L16.5 16.5ZM16.5 15L16.85 15C19.95 15 21 13.95 21 10.8501L21 6.6499C21 3.55005 19.95 2.5 16.85 2.5L12.65 2.5C9.55005 2.5 8.5 3.55005 8.5 6.6499L8.5 7L10.85 7C14.76 7 16.5 8.73999 16.5 12.6499L16.5 15ZM7.75 8.5L6.65002 8.5C3.55005 8.5 2.5 9.55005 2.5 12.6499L2.5 16.8501C2.5 19.95 3.55005 21 6.65002 21L10.85 21C13.95 21 15 19.95 15 16.8501L15 12.6499C15 9.55005 13.95 8.5 10.85 8.5L7.75 8.5Z"
					clip-rule="evenodd"
					fill="#77797C"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconCopy extends Vue {}
</script>

<style scoped lang="scss">
.icon-copy {
	display: flex;
}
</style>
